import { render, staticRenderFns } from "./UserInfoBox.vue?vue&type=template&id=6eba7b20&scoped=true&"
import script from "./UserInfoBox.vue?vue&type=script&lang=js&"
export * from "./UserInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoBox.vue?vue&type=style&index=0&id=6eba7b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba7b20",
  null
  
)

export default component.exports